import { acceptHMRUpdate, defineStore } from 'pinia'
import { until } from '~/assets/scripts/helpers'
import { useCacheStore } from '~/stores/cache'

export const useMiscStore = defineStore('misc', {
  state: () => ({
    stores: {} as { [key: string]: any },
    fetching_stores: false,
    no_vendor_images: [] as Array<string>,
    vendor_images_loaded: false,
    showcloud_french_descriptions: false,
    showcloud_sales_history_start: null as null | Date,
    showcloud_sales_history_end: null as null | Date,
  }),
  actions: {
    toggleFrenchDescriptions(checked: boolean) {
      this.$patch({ showcloud_french_descriptions: checked })
      if (checked) {
        localStorage.setItem('scFrenchDescriptions', '1')
      } else {
        localStorage.removeItem('scFrenchDescriptions')
      }
    },
    setSalesHistoryRange(payload: { start: null | Date; end: null | Date }) {
      sessionStorage.setItem('scSalesHistory', JSON.stringify(payload))
      this.$patch({
        showcloud_sales_history_start: payload.start,
        showcloud_sales_history_end: payload.end,
      })
    },
    setStoreInfo(payload: { [key: string]: any }) {
      this.$patch((state) => {
        state.stores[payload.store_number] = payload
      })
    },
    getLocation() {
      const ex = sessionStorage.getItem('currentPosition')
      if (ex) {
        const u = JSON.parse(ex)
        if (u) {
          return Promise.resolve(u)
        }
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (resp) => {
            sessionStorage.setItem(
              'currentPosition',
              JSON.stringify([resp.coords.latitude, resp.coords.longitude]),
            )
            return Promise.resolve([resp.coords.latitude, resp.coords.longitude])
          },
          (_) => {
            return Promise.resolve(null)
          },
          { maximumAge: 3600 * 1000 },
        )
      }
      return Promise.resolve(null)
    },
    async getStoreInfo(store_number: number) {
      if (!(store_number in this.$state.stores)) {
        this.setStoreInfo({ store_number: store_number })
      }

      if (!this.$state.fetching_stores) {
        this.$patch({ fetching_stores: true })
      } else {
        await until(() => !this.$state.fetching_stores)
      }

      useCacheStore()
        .get('/api/store-info')
        .then((data: { [key: string]: any }) => {
          for (const store of Object.values(data)) {
            this.setStoreInfo(store)
          }
          this.$patch({ fetching_stores: false })
        })
    },
    initVendorImages() {
      if (!this.$state.vendor_images_loaded) {
        const e = sessionStorage.getItem('noVendorImages')
        this.$patch({ no_vendor_images: e ? JSON.parse(e) : [], vendor_images_loaded: true })
      }
    },
    noVendorImage(vendor_code: string) {
      if (this.$state.vendor_images_loaded && !this.$state.no_vendor_images.includes(vendor_code)) {
        this.$patch((state) => state.no_vendor_images.push(vendor_code))
        sessionStorage.setItem('noVendorImages', JSON.stringify(this.$state.no_vendor_images))
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMiscStore, import.meta.hot))
}
